

function NameTeamLayout({ name, score, isWin, state }) {
    return (
        <div className="flex flex-row text-[#fff]">
            <h2 className="flex-1 text-lg">{name}</h2>
            {state !== "SOON" && (
                <h3 className={` ${isWin ? "text-[#fc982d]" : ""}`}>{score}</h3>
            )}
        </div>
    );
}

export function CardMatch({ participants, datetime, state }) {
    const datetimeArray = datetime.split(" ");
    const date = datetimeArray[0];
    const time = `${datetimeArray[1]} ${datetimeArray[2]}`;

    return (
        <div className="bg-[#09383d] rounded-md py-3 flex flex-row border-2 border-lightDarkBackground w-full">
            <div className="flex-1 border-r-2 pl-6 pr-4 border-lightDarkBackground flex flex-col gap-4 justify-center w-9/12 md:w-10/12">
                <NameTeamLayout
                    name={participants[0].name}
                    score={participants[0].resultText}
                    isWin={
                        state === "DONE" &&
                        participants[0].isWinner
                    }
                    state={state}
                />
                <NameTeamLayout
                    name={participants[1].name}
                    score={participants[1].resultText}
                    isWin={
                        state === "DONE" &&
                        participants[1].isWinner
                    }
                    state={state}
                />
            </div>
            {state === "LIVE" ? (
                <div className="flex justify-center items-center py-2 px-6 text-lg text-red-600 w-3/12 md:w-2/12">
                    <div className="flex">
                        <span className="rounded-full mr-2 live-icon" />
                    </div>
                    <div className="font-bold">
                        {state}
                    </div>
                </div>
            ) : state === 'DONE' ? (
                <div className="flex justify-center items-center py-2 px-6 text-lg text-green-600 w-3/12 md:w-2/12">
                    <div className="text-lg">Final Score</div>
                </div>
            ) :
                (
                    <div className="flex flex-col justify-center items-center py-2 px-6 text-lg text-grayText w-3/12 md:w-2/12">
                        <time>{datetime}</time>
                        {/* <time>{time}</time> */}
                    </div>
                )}
        </div>
    );
}